<!-- Toast notifications -->
<p-toast key="main"></p-toast>
<p-toast key="checkout"></p-toast>

<!-- Main Cart Container -->
<div class="clinic-cart-container" *ngIf="cartItems.length > 0; else showItems">
  <!-- Modern Header Section -->
  <div class="m-4">
    <div class="clinic-cart-header">
      <div class="header-content">
        <div class="header-left">
          <h1 class="clinic-cart-title">
            <i class="pi pi-shopping-cart mr-3"></i>
            Your Cart
          </h1>
          <p class="clinic-cart-subtitle">
            Review and manage your selected items
          </p>
        </div>
        <div class="header-right">
          <div class="cart-summary">
            <span class="item-count">{{ cartItems.length }} items</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Cart Content -->
  <div class="clinic-cart-content">
    <div class="cart-layout">
      <!-- Cart Items Section -->
      <div class="cart-items-section">
        <div class="section-header">
          <h2 class="section-title">Cart Items</h2>
        </div>
        
        <div class="cart-items-list">
          <div 
            *ngFor="let cartItem of cartItems; let i = index" 
            class="cart-item-card"
          >
            <div class="item-content">
              <div class="item-image">
                <img
                  [src]="cartItem.image_url"
                  alt="product image"
                  class="product-image"
                />
              </div>
              
              <div class="item-details">
                <h3 class="item-name">{{ cartItem.product_name }}</h3>
                <p class="item-description">{{ cartItem.description }}</p>
                <div class="item-quantity">
                  <span class="quantity-label">Quantity:</span>
                  <span class="quantity-value">{{ cartItem.quantity }}</span>
                </div>
              </div>
              
              <div class="item-actions">
                <div class="item-price">
                  <span class="price-amount">
                    {{ cartItem.cost_excl_vat * cartItem.total_quantity | currency:'R':'symbol':'' }}
                  </span>
                </div>
                <button
                  pButton
                  pRipple
                  icon="pi pi-trash"
                  class="modern-button danger small"
                  (click)="removeItem(i)"
                  title="Remove item"
                ></button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Order Summary Section -->
      <div class="order-summary-section">
        <div class="summary-card">
          <div class="summary-header">
            <h3 class="summary-title">
              <i class="pi pi-receipt mr-2"></i>
              Order Summary
            </h3>
          </div>
          
          <div class="summary-content">
            <div class="summary-row">
              <span class="summary-label">Subtotal</span>
              <span class="summary-value">{{ cost_excl_vat | currency: 'R' }}</span>
            </div>
            
            <div class="summary-row">
              <span class="summary-label">VAT</span>
              <span class="summary-value">{{ cost_incl_vat - cost_excl_vat | currency: 'R'}}</span>
            </div>
            
            <div class="summary-divider"></div>
            
            <div class="summary-row total">
              <span class="summary-label">Total</span>
              <span class="summary-value total-amount">{{ cost_incl_vat | currency: 'R' }}</span>
            </div>
            
            <div class="courier-disclaimer">
              <i class="pi pi-info-circle"></i>
              <p>
                Courier/delivery costs will be added separately. The total shown excludes courier charges.
              </p>
            </div>
          </div>
          
          <div class="summary-actions">
            <button
              pButton
              pRipple
              [loading]="loading"
              [disabled]="loading"
              (click)="checkOut(cartItems)"
              label="Order Now"
              icon="pi pi-credit-card"
              class="modern-button primary full-width"
            ></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Empty Cart Template -->
<ng-template #showItems>
  <!-- Thank You Page -->
  <div class="thank-you-container" *ngIf="checkedOut; else noCheckout">
    <div class="thank-you-content">
      <div class="thank-you-card">
        <div class="thank-you-icon">
          <i class="pi pi-check-circle"></i>
        </div>
        <h1 class="thank-you-title">Thank you!</h1>
        <p class="thank-you-message">Your order is being processed.</p>
        <button
          class="modern-button primary"
          type="button"
          pButton
          pRipple
          label="Go Home"
          icon="pi pi-home"
          [routerLink]="['/']"
        ></button>
      </div>
    </div>
  </div>

  <!-- Empty Cart Page -->
  <ng-template #noCheckout>
    <div class="empty-cart-container" *ngIf="!checkedOut">
      <div class="empty-cart-content">
        <div class="empty-cart-card">
          <div class="empty-cart-icon">
            <i class="pi pi-shopping-cart"></i>
          </div>
          <h2 class="empty-cart-title">Your cart is empty</h2>
          <p class="empty-cart-message">Add some items to get started</p>
          <button
            class="modern-button primary"
            type="button"
            pButton
            pRipple
            label="Go Home"
            icon="pi pi-home"
            [routerLink]="['/']"
          ></button>
        </div>
      </div>
    </div>
  </ng-template>
</ng-template>
